module.exports = typeof templateVars !== 'undefined' && typeof testComponentName !== 'undefined' && testComponentName === 'search-form/extendable' && templateVars.config ?
				templateVars.config :
				{
	"searchMessageBottom": true,
	"cleanInputOnBlur": true
};


//////////////////
// WEBPACK FOOTER
// ./temp/components/search-form/extendable/config.yaml
// module id = 103
// module chunks = 0